import { createFileRoute } from "@tanstack/react-router";
import { RouteGuardPermissions } from "@/components/permissions/route-guard-multiple";
import DebitNoteDetail from "@/components/invoices/debits/debit-note-detail";

export const Route = createFileRoute("/_authenticated/invoices/debit-notes/$debitNoteId/")({
  component: DebitNoteDetailPage,
});

function DebitNoteDetailPage() {
  const { debitNoteId } = Route.useParams();
  return (
    <RouteGuardPermissions
      permissions={[{ module: "debit_notes", actions: ["read"] }]}
    >
      <DebitNoteDetail debitNoteId={debitNoteId} />
    </RouteGuardPermissions>
  );
}
